import { useEffect, useRef } from 'react';
import api from '../api/client';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64  = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw     = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

async function registerServiceWorker() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;
    return reg;
  } catch (err) {
    console.warn('SW kaydı başarısız:', err);
    return null;
  }
}

async function subscribe(reg) {
  try {
    const existing = await reg.pushManager.getSubscription();
    if (existing) return existing;

    return await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });
  } catch (err) {
    console.warn('Push aboneliği başarısız:', err);
    return null;
  }
}

export function usePushSubscription(isLoggedIn) {
  const done = useRef(false);

  useEffect(() => {
    if (!isLoggedIn || done.current || !VAPID_PUBLIC_KEY) return;

    (async () => {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') return;

      const reg = await registerServiceWorker();
      if (!reg) return;

      const subscription = await subscribe(reg);
      if (!subscription) return;

      try {
        await api.post('/users/push-subscription', { subscription });
        done.current = true;
      } catch (err) {
        console.warn('Abonelik kaydedilemedi:', err);
      }
    })();
  }, [isLoggedIn]);
}
